import React from 'react';
import { classes } from './FacebookPost.st.css.js';
import { dataHooks, PUBLISH_DATE_JUST_NOW } from '../constants';
import { Avatar, Text } from '../..';
import Caption from '../../Text/Caption';
export const FacebookPost = ({ profileName, profileImageSrc, caption, media }) => {
    const _renderAccountDetailsAndPublishDate = () => (React.createElement("div", { className: classes.postHeader },
        React.createElement(Avatar, { size: "size24", imgProps: { src: profileImageSrc }, dataHook: dataHooks.socialPostPreviewProfileImage }),
        React.createElement("div", { className: classes.profileNameAndPublishDate },
            React.createElement(Text, { size: "tiny", weight: "normal", dataHook: dataHooks.socialPostPreviewProfileName }, profileName),
            React.createElement(Caption, { className: classes.lastSeenCaption, tagName: "span", caption: "c1", dataHook: "justNow", light: false }, PUBLISH_DATE_JUST_NOW))));
    const _renderCaption = () => (React.createElement("div", { className: classes.postCaption, "data-hook": dataHooks.socialPostPreviewCaption },
        React.createElement(Text, { size: "tiny" }, caption)));
    const _renderMedia = () => (React.createElement("div", { "data-hook": dataHooks.socialPostPreviewMedia }, media));
    return (React.createElement(React.Fragment, null,
        _renderAccountDetailsAndPublishDate(),
        caption && _renderCaption(),
        media && _renderMedia()));
};
//# sourceMappingURL=FacebookPost.js.map